import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="footer py-3 py-lg-5">
      <div className="container-xxl lh-sm text-center">
        <p style={{ fontSize: '12px' }}>
          Mutual Advisors Insurance Agency's website is operated by Mutual Advisors Insurance Agency, LLC a licensed health insurance agency doing business as Mutual Advisors Insurance Agency. The purpose of this site is the solicitation of insurance. Contact may be made by an insurance agent/producer or insurance company.
          <br/><br/>We do not offer every plan available in your area. Currently we represent [insert number of organizations] organizations which offer [insert number of plans] products in your area. Please contact Medicare.gov, 1-800-MEDICARE, or your local State Health Insurance Program (SHIP) to get information on all of your options.
          <br/><br/>Our website is a website owned and operated by Mutual Advisors Insurance Agency. Enrollment in any plan depends on contract renewal.
          <br/><br/>Mutual Advisors Insurance Agency & it's Third-party partners may call you are not connected with or endorsed by the U.S. Government or the federal Medicare program. This website does not contain a complete listing of plans available in your service area. For a complete listing please contact 1-800-MEDICARE (TTY users should call (877) 486-2048), 24 hours a day / 7 days a week or consult www.medicare.gov. Not all plans or products are available in all markets. Additional plans may be available in your service area.
        </p>
        <p>
          <a href="https://oyster-app-2-absn2.ondigitalocean.app/privacy">Privacy Policy</a> | <a href="https://oyster-app-2-absn2.ondigitalocean.app/terms">Terms and Conditions</a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
